import { BodyMD, BodyMDB } from "../../../typography";
import {
  FooterSection,
  companyLinks,
  socialLinks,
} from "../config/footerConfig";

import { FooterLink } from "../config/footerConfig";
import { Link } from "react-router-dom";

export const FooterLinks = () => {
  const renderLink = (link: FooterLink) => {
    if (link.isExternal) {
      return (
        <a
          key={link.title}
          className="tw-no-underline"
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
        >
          <BodyMD className="tw-mb-0 tw-text-white tw-text-opacity-60 hover:tw-underline">
            {link.title}
          </BodyMD>
        </a>
      );
    }

    return (
      <Link to={link.href} key={link.title} className="tw-no-underline">
        <BodyMD className="tw-mb-0 tw-text-white tw-text-opacity-60 hover:tw-underline">
          {link.title}
        </BodyMD>
      </Link>
    );
  };

  const renderSection = (section: FooterSection) => (
    <div key={section.title} className="tw-flex tw-flex-col tw-gap-y-[3em]">
      <div className="tw-flex tw-flex-col tw-gap-y-[1.25em]">
        <div className="tw-flex tw-flex-col">
          <BodyMDB className="tw-mb-0 tw-text-white">{section.title}</BodyMDB>
        </div>
        <div className="tw-flex tw-flex-col tw-gap-y-[.625em] tw-text-white tw-text-opacity-60">
          {section.links.map(renderLink)}
        </div>
      </div>
    </div>
  );

  return (
    <div className="tw-z-20 tw-flex tw-w-fit tw-gap-x-[6.25em]">
      {renderSection(companyLinks)}
      {renderSection(socialLinks)}
    </div>
  );
};
